import React, { memo, useState } from 'react'

import VerificationSuccess from './VerificationSuccess'
import VerificationError from './VerificationError'
import TokenExpired from './TokenExpired'
import EmailVerification from './EmailVerification'
import VerificationClosed from './VerificationClosed'

const VerificationHome = memo((props) => {
  const [currentState, setCurrentState] = useState('VERIFY')
  const [requestId, setRequestId] = useState('')

  const updateState = (state) => {
    setCurrentState(state)
  }
  const showState = (state) => {
    const VERIFICATION_STATES = {
      EXPIRED: <TokenExpired reqid={requestId} {...props} />,
      ERROR: <VerificationError changeState={updateState} {...props} />,
      SUCCESS: <VerificationSuccess reqid={requestId} {...props} />,
      CLOSED: <VerificationClosed changeState={updateState} {...props} />,
      VERIFY: (
        <EmailVerification
          changeState={updateState}
          setReqId={setRequestId}
          {...props}
        />
      ),
    }
    return VERIFICATION_STATES[state]
  }

  return <>{showState(currentState)}</>
})
VerificationHome.displayName = 'VerificationHome'

export default VerificationHome
